import { CheckCircleOutlined } from '@ant-design/icons';
import { ScopeButton } from '@monorepo/shared-lib';
import { ReactComponent as HmrcIcon } from 'assets/images/icons/hmrcIcon.svg';
import { StyledTooltip } from 'components/Custom/Tooltip';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

const HmrcButton = styled(ScopeButton)<{ $connected?: boolean }>`
  && {
    font-size: 13px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  && .ant-btn-icon {
    display: inline-flex;
    align-items: center;
    line-height: 0;
  }

  ${({ $connected }) =>
    $connected &&
    css`
      &&:not(:hover):not(:focus) {
        border: 1px solid var(--color-primary, #41aaaf) !important;
        background: var(--color-layout-bg, #e9f6f7) !important;
        color: var(--color-text-dark, #042a2a) !important;
        box-shadow: none !important;
      }
    `}
`;

const CheckSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-right: 6px;
  flex-shrink: 0;
`;

const ConnectedCheck = styled(CheckCircleOutlined)<{ $invisible?: boolean }>`
  && {
    color: var(--color-primary, #41aaaf);
    font-size: 14px;
    opacity: ${({ $invisible }) => ($invisible ? 0 : 1)};
  }
`;

export type HmrcConnectButtonProps = {
  connected: boolean;
  onConnect: () => void;
};

export const HmrcConnectButton: React.FC<HmrcConnectButtonProps> = ({
  connected,
  onConnect,
}) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = React.useState(false);

  const label = connected
    ? hovered
      ? t('organisation.reconnect-hmrc')
      : t('organisation.hmrc-connected')
    : t('organisation.connect-hmrc');

  const tooltip = connected
    ? t('organisation.hmrc-connected-tooltip')
    : t('organisation.connect-hmrc-tooltip');

  return (
    <StyledTooltip title={tooltip} placement="top" arrow={false}>
      <HmrcButton
        type="default" //@ts-ignore
        width="210px"
        height="32px"
        $connected={connected}
        aria-label={label}
        icon={
          <HmrcIcon
            aria-hidden
            style={{
              width: 18,
              height: 18,
              display: 'block',
            }}
          />
        }
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => setHovered(true)}
        onBlur={() => setHovered(false)}
        onClick={onConnect}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          {connected ? (
            <CheckSlot aria-hidden>
              <ConnectedCheck $invisible={hovered} />
            </CheckSlot>
          ) : null}
          {label}
        </span>
      </HmrcButton>
    </StyledTooltip>
  );
};
